

import { Component, Vue } from "vue-property-decorator";

export default Vue.extend({
  name: "myNav",
  components: {
    
  },
  computed: {
    btnWidth() {
      const that = this as any;
      return that.$vuetify.breakpoint.name == "xl" ||
        that.$vuetify.breakpoint.name == "lg"
        ? "110px"
        : "90px";
    },
    btnHeight() {
      const that = this as any;
      return that.$vuetify.breakpoint.name == "xl" ||
        that.$vuetify.breakpoint.name == "lg"
        ? "55px"
        : "34px";
    },
  },
});


